import { render, staticRenderFns } from "./index-send.vue?vue&type=template&id=1830e562&scoped=true"
import script from "./index-send.vue?vue&type=script&lang=js"
export * from "./index-send.vue?vue&type=script&lang=js"
import style0 from "./index-send.vue?vue&type=style&index=0&id=1830e562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830e562",
  null
  
)

export default component.exports